import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../context/ToastContext";
import API from "../api"; // path check kar lena

// --------------------------------
//  CONFIRM SUBMIT MODAL
// --------------------------------
function ConfirmSubmitModal({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-96 p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          📝 Submit Your Test
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          Are you sure you want to submit this test? Once submitted, you can’t change your answers.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md"
          >
            ✅ Submit
          </button>
        </div>
      </div>
    </div>
  );
}

// --------------------------------
//  MAIN COMPONENT
// --------------------------------

export default function AttemptTest() {
  const { type , id } = useParams();
  
  const navigate = useNavigate();
  const location = useLocation();   // ⭐ get timeLimit from navigation state
  const passedTimeLimit = location.state?.timeLimit || null;

  const [test, setTest] = useState(null);
  const [answers, setAnswers] = useState({});
  const [marked, setMarked] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // ⭐ TIMER
  const [timeLeft, setTimeLeft] = useState(null);

  //const BASE_URL = "https://bharatparikhsa-backend.onrender.com/api";
  //const token = localStorage.getItem("token");
  const { showToast } = useToast();

  // ---------------------------------------------------
  // Fetch Test Details
  // ---------------------------------------------------
  useEffect(() => {
    const fetchTest = async () => {
      /*if (!token) {
        setError("Please login to attempt the test");
        setLoading(false);
        return;
      }*/

      try {
        const res = await API.get(`/test-types/${type}/${id}`);
        const data = res.data;

        /*const res = await fetch(`${BASE_URL}/test-types/${type}/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(`Error fetching test: ${res.status}`);

        const data = await res.json();*/
        // ✅ TEST START EVENT (ADD THIS)
      await API.post("/events/track", {
        eventName: "test_started",
        eventType: "test",
        entityId: id,
        metadata: {
          testType: type,
          totalQuestions: data.questions.length
        }
      });

        const mappedQuestions = data.questions.map(q => {

 let correctIndex = null;

 if (typeof q.answer === "object" && q.answer !== null) {
   correctIndex = q.answer.index;
 }
 else if (typeof q.answer === "number") {
   correctIndex = q.answer;
 }
 else if (typeof q.answer === "string") {

  const val = q.answer.trim().toUpperCase();

  // LETTER BASED (A,B,C,D,E)
  if (/^[A-Z]$/.test(val)) {
    correctIndex = val.charCodeAt(0) - 65;
  }

  // fallback: match by text
  else {
    const found = q.options?.findIndex(
      o => o.text?.toLowerCase() === val.toLowerCase()
    );

    if (found !== -1) correctIndex = found;
  }
}

 return {
   ...q,
   type: q.type?.toLowerCase() || "mcq",
   correctIndex
 };
});

        // ⭐ Set timeLeft for timed test only
        if (data.type === "timed") {
          const t = data.timeLimit || passedTimeLimit;
          if (t) setTimeLeft(t);
        }

        setTest({ ...data, questions: mappedQuestions });
      } catch (err) {
        console.error("❌ Error fetching test:", err);
        setError("Failed to load test details");
      } finally {
        setLoading(false);
      }
    };

    fetchTest();
  }, [id, type]);

  // ---------------------------------------------------
  // TIMER - Auto Countdown
  // ---------------------------------------------------
  useEffect(() => {
    if (timeLeft === null) return;

    if (timeLeft === 0) {
      showToast("⏳ Time is up! Auto-submitting...");
      handleSubmit();
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  // ---------------------------------------------------
  // Handlers
  // ---------------------------------------------------
  const handleChange = (qId, value) =>
    setAnswers((prev) => ({ ...prev, [qId]: value }));

  const handleMarkForReview = (qId) =>
    setMarked((prev) => ({
      ...prev,
      [qId]: prev[qId] === "review" ? null : "review",
    }));

  const handleClearResponse = (qId) => {
    setAnswers((prev) => {
      const updated = { ...prev };
      delete updated[qId];
      return updated;
    });
    setMarked((prev) => ({ ...prev, [qId]: null }));
  };

  const handleSubmitClick = () => setShowConfirmModal(true);
  // ⭐ FINAL SUBMIT FUNCTION (NO BACKEND SCORE – ONLY FRONTEND)
const handleSubmit = async () => {
  const result = calculateScoreFrontend();

  // 🔥 SAVE TEST RESULT TO BACKEND
  await API.post("/tests/save", {
  testId: id,
  testName: test.title,
  score: result.score,
  total: result.total,
  correct: result.correct,
  wrong: result.wrong,
  unattempted: result.skipped
});

  // optional analytics
  await API.post("/events/track", {
    eventName: "test_submitted",
    eventType: "test",
    entityId: id,
    metadata: result
  });

  navigate(`/result/${id}`, {
    state: {
      test,
      answers,
      marked,
      score: result.score,
      correctAnswers: result.correct,
      wrongAnswers: result.wrong,
      skipped: result.skipped,
      total: result.total
    },
  });
};


    // ⭐ FRONTEND SCORE CALCULATOR (NO BACKEND)
  const calculateScoreFrontend = () => {
  let correct = 0;
  let wrong = 0;
  let skipped = 0;

  test.questions.forEach((q) => {
    const userAns = answers[q._id];

    if (userAns === undefined) {
      skipped++;
      return;
    }

    // TEXT TYPE
    if (q.type === "text") {
      if (
        userAns?.toLowerCase().trim() ===
        q.answer?.toLowerCase().trim()
      ) {
        correct++;
      } else {
        wrong++;
      }
      return;
    }

    // TRUE/FALSE (string comparison)
if (q.type === "truefalse") {
  const correctIndex =
    q.answer === true || q.answer === "True"
      ? 0
      : 1;

  if (userAns === correctIndex) {
    correct++;
  } else {
    wrong++;
  }
  return;
}
    // MCQ (index comparison)
    if (userAns === q.correctIndex) {
      correct++;
    } else {
      wrong++;
    }
  });

  return {
    correct,
    wrong,
    skipped,
    total: test.questions.length,
    score: correct,
  };
};





  const handleNext = () =>
    currentIndex < test.questions.length - 1 &&
    setCurrentIndex(currentIndex + 1);

  const handlePrev = () =>
    currentIndex > 0 && setCurrentIndex(currentIndex - 1);

  // ---------------------------------------------------
  // Rendering
  // ---------------------------------------------------
  if (loading) return <p className="p-8 text-center">Loading test...</p>;
  if (error) return <p className="p-8 text-center text-red-500">{error}</p>;
  if (!test) return null;

  const total = test.questions.length;
  const q = test.questions[currentIndex];
  const qId = q._id;

  const getStatus = (qId) => {
  if (answers[qId] !== undefined) return "answered";
  if (marked[qId] === "review") return "review";
  return "notVisited";
};

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row">
      {/* -------------------------------- Sidebar -------------------------------- */}
      <aside className="md:w-1/4 bg-white shadow-lg p-5 border-r border-gray-200">
        <h2 className="text-xl font-bold text-blue-700 mb-4 text-center">
          🧭 Question Navigator
        </h2>

        <div className="grid grid-cols-5 sm:grid-cols-6 md:grid-cols-4 lg:grid-cols-5 gap-3 justify-center">
          {test.questions.map((question, index) => {
            const status = getStatus(question._id);
            return (
              <button
                key={question._id}
                onClick={() => setCurrentIndex(index)}
                className={`w-10 h-10 rounded-full text-sm font-semibold border-2 ${
                  currentIndex === index
                    ? "border-blue-600 text-blue-700 bg-blue-100"
                    : status === "answered"
                    ? "bg-green-500 text-white border-green-500"
                    : status === "review"
                    ? "bg-yellow-400 text-white border-yellow-400"
                    : "bg-gray-200 text-gray-600 border-gray-200"
                }`}
              >
                {index + 1}
              </button>
            );
          })}
        </div>

        <div className="mt-6 text-sm text-gray-600">
          <p>🟩 Attempted</p>
          <p>🟨 Marked for Review</p>
          <p>⚪ Not Visited</p>
        </div>
      </aside>

      {/* -------------------------------- Main Content -------------------------------- */}
      <main className="flex-1 p-6 md:p-10">
        {/* Header */}
        <div className="flex justify-between items-center mb-5">
          <h1 className="text-2xl font-bold text-blue-700">
            {test?.title || "Untitled Test"}
          </h1>

          {/* ⭐ TIMER UI */}
          {test.type === "timed" && timeLeft !== null && (
            <div className="text-xl font-bold text-red-600 bg-red-100 px-4 py-2 rounded-lg shadow">
              ⏱ Time Left: {Math.floor(timeLeft / 60)}:
              {(timeLeft % 60).toString().padStart(2, "0")}
            </div>
          )}
        </div>

        {/* Question */}
        <div className="bg-white shadow-xl rounded-2xl p-6 border border-gray-100">
          <h2 className="text-lg font-semibold mb-4 text-gray-800">
            {q?.question}
          </h2>

          {/* Options */}
          {q?.type === "mcq" ? (
            q.options.map((opt, i) => (
  <label
    key={opt.key || i}
    className={`block border rounded-lg px-4 py-2 mb-2 cursor-pointer hover:bg-blue-50 ${
      answers[qId] === i
        ? "border-blue-600 bg-blue-100"
        : "border-gray-200"
    }`}
  >
    <input
      type="radio"
      name={qId}
      value={opt.text}
      checked={answers[qId] === i}
      onChange={() => handleChange(qId, i)}
      className="mr-2 accent-blue-600"
    />

    {/* OPTION TEXT */}
    <div>{typeof opt === "object" ? opt.text : opt}</div>

    {/* OPTION IMAGE */}
    {opt.media?.url && (
      <img
        src={`${process.env.REACT_APP_API_BASE_URL}${opt.media.url}`}
        alt=""
        className="mt-2 max-w-xs rounded border"
      />
    )}
  </label>
))

          ) :q?.type === "truefalse" ? (
  ["True", "False"].map((val, i) => (
    <label
      key={val}
      className={`block border rounded-lg px-4 py-2 mb-2 cursor-pointer hover:bg-indigo-50 ${
        answers[qId] === i
          ? "border-indigo-600 bg-indigo-100"
          : "border-gray-200"
      }`}
    >
      <input
        type="radio"
        name={qId}
        checked={answers[qId] === i}
        onChange={() => handleChange(qId, i)}
        className="mr-2 accent-indigo-600"
      />
      {val}
    </label>
  ))
)  : (
            <input
              type="text"
              value={answers[qId] || ""}
              onChange={(e) => handleChange(qId, e.target.value)}
              placeholder="Type your answer..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
            />
          )}

          {/* Action Buttons */}
          <div className="flex justify-between items-center mt-6">
            <button
              onClick={() => handleMarkForReview(qId)}
              className={`px-4 py-2 rounded-lg font-medium ${
                marked[qId] === "review"
                  ? "bg-yellow-500 text-white hover:bg-yellow-600"
                  : "bg-yellow-100 text-yellow-700 hover:bg-yellow-200"
              }`}
            >
              {marked[qId] === "review" ? "✓ Marked for Review" : "Mark for Review"}
            </button>

            <button
              onClick={() => handleClearResponse(qId)}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-medium"
            >
              Clear Response
            </button>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-8">
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className={`px-6 py-2 rounded-lg font-medium ${
              currentIndex === 0
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-600 text-white hover:bg-gray-700"
            }`}
          >
            ← Previous
          </button>

          {/* Submit / Next */}
          {currentIndex === total - 1 ? (
            <button
              onClick={handleSubmitClick}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-medium"
            >
              Submit Test
            </button>
          ) : (
            <button
              onClick={handleNext}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium"
            >
              Next →
            </button>
          )}
        </div>

        {showConfirmModal && (
          <ConfirmSubmitModal
            onConfirm={() => {
              handleSubmit();
              setShowConfirmModal(false);
            }}
            onCancel={() => setShowConfirmModal(false)}
          />
        )}
      </main>
    </div>
  );
}
